"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/bitcoin-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 5.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1Api = exports.V1ApiFactory = exports.V1ApiFp = exports.V1ApiAxiosParamCreator = exports.ValidationErrorMessageEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var ValidationErrorMessageEnum;
(function (ValidationErrorMessageEnum) {
    ValidationErrorMessageEnum["ValidationFailed"] = "Validation failed";
})(ValidationErrorMessageEnum = exports.ValidationErrorMessageEnum || (exports.ValidationErrorMessageEnum = {}));
/**
 * V1Api - axios parameter creator
 * @export
 */
const V1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get account details by address or xpub  Examples 1. Bitcoin (address) 2. Bitcoin (xpub)
         * @param {string} pubkey account address or xpub
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: (pubkey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pubkey' is not null or undefined
            common_1.assertParamExists('getAccount', 'pubkey', pubkey);
            const localVarPath = `/api/v1/account/{pubkey}`
                .replace(`{${"pubkey"}}`, encodeURIComponent(String(pubkey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get information about the running coinstack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets current network fee estimates for \'fast\', \'average\', and \'slow\' tx confirmation times
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkFees: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get transaction specific data directly from the node
         * @param {string} txid transaction hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaction: (txid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'txid' is not null or undefined
            common_1.assertParamExists('getTransaction', 'txid', txid);
            const localVarPath = `/api/v1/transaction/{txid}`
                .replace(`{${"txid"}}`, encodeURIComponent(String(txid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get transaction history by address or xpub
         * @param {string} pubkey account address or xpub
         * @param {number} [page] page number
         * @param {number} [pageSize] page size
         * @param {string} [contract] filter by contract address (only supported by coins which support contracts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxHistory: (pubkey, page, pageSize, contract, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pubkey' is not null or undefined
            common_1.assertParamExists('getTxHistory', 'pubkey', pubkey);
            const localVarPath = `/api/v1/account/{pubkey}/txs`
                .replace(`{${"pubkey"}}`, encodeURIComponent(String(pubkey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (contract !== undefined) {
                localVarQueryParameter['contract'] = contract;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all unspent transaction outputs for an address or xpub  Examples 1. Bitcoin (address) 2. Bitcoin (xpub)
         * @param {string} pubkey account address or xpub
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtxos: (pubkey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pubkey' is not null or undefined
            common_1.assertParamExists('getUtxos', 'pubkey', pubkey);
            const localVarPath = `/api/v1/account/{pubkey}/utxos`
                .replace(`{${"pubkey"}}`, encodeURIComponent(String(pubkey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Sends raw transaction to be broadcast to the node.
         * @param {SendTxBody} sendTxBody serialized raw transaction hex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTx: (sendTxBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sendTxBody' is not null or undefined
            common_1.assertParamExists('sendTx', 'sendTxBody', sendTxBody);
            const localVarPath = `/api/v1/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(sendTxBody, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.V1ApiAxiosParamCreator = V1ApiAxiosParamCreator;
/**
 * V1Api - functional programming interface
 * @export
 */
const V1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.V1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Get account details by address or xpub  Examples 1. Bitcoin (address) 2. Bitcoin (xpub)
         * @param {string} pubkey account address or xpub
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(pubkey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccount(pubkey, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get information about the running coinstack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInfo(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets current network fee estimates for \'fast\', \'average\', and \'slow\' tx confirmation times
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkFees(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getNetworkFees(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get transaction specific data directly from the node
         * @param {string} txid transaction hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaction(txid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTransaction(txid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get transaction history by address or xpub
         * @param {string} pubkey account address or xpub
         * @param {number} [page] page number
         * @param {number} [pageSize] page size
         * @param {string} [contract] filter by contract address (only supported by coins which support contracts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxHistory(pubkey, page, pageSize, contract, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTxHistory(pubkey, page, pageSize, contract, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get all unspent transaction outputs for an address or xpub  Examples 1. Bitcoin (address) 2. Bitcoin (xpub)
         * @param {string} pubkey account address or xpub
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtxos(pubkey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUtxos(pubkey, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Sends raw transaction to be broadcast to the node.
         * @param {SendTxBody} sendTxBody serialized raw transaction hex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTx(sendTxBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendTx(sendTxBody, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.V1ApiFp = V1ApiFp;
/**
 * V1Api - factory interface
 * @export
 */
const V1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.V1ApiFp(configuration);
    return {
        /**
         * Get account details by address or xpub  Examples 1. Bitcoin (address) 2. Bitcoin (xpub)
         * @param {string} pubkey account address or xpub
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(pubkey, options) {
            return localVarFp.getAccount(pubkey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get information about the running coinstack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo(options) {
            return localVarFp.getInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets current network fee estimates for \'fast\', \'average\', and \'slow\' tx confirmation times
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkFees(options) {
            return localVarFp.getNetworkFees(options).then((request) => request(axios, basePath));
        },
        /**
         * Get transaction specific data directly from the node
         * @param {string} txid transaction hash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaction(txid, options) {
            return localVarFp.getTransaction(txid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get transaction history by address or xpub
         * @param {string} pubkey account address or xpub
         * @param {number} [page] page number
         * @param {number} [pageSize] page size
         * @param {string} [contract] filter by contract address (only supported by coins which support contracts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxHistory(pubkey, page, pageSize, contract, options) {
            return localVarFp.getTxHistory(pubkey, page, pageSize, contract, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all unspent transaction outputs for an address or xpub  Examples 1. Bitcoin (address) 2. Bitcoin (xpub)
         * @param {string} pubkey account address or xpub
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtxos(pubkey, options) {
            return localVarFp.getUtxos(pubkey, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends raw transaction to be broadcast to the node.
         * @param {SendTxBody} sendTxBody serialized raw transaction hex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTx(sendTxBody, options) {
            return localVarFp.sendTx(sendTxBody, options).then((request) => request(axios, basePath));
        },
    };
};
exports.V1ApiFactory = V1ApiFactory;
/**
 * V1Api - object-oriented interface
 * @export
 * @class V1Api
 * @extends {BaseAPI}
 */
class V1Api extends base_1.BaseAPI {
    /**
     * Get account details by address or xpub  Examples 1. Bitcoin (address) 2. Bitcoin (xpub)
     * @param {V1ApiGetAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getAccount(requestParameters, options) {
        return exports.V1ApiFp(this.configuration).getAccount(requestParameters.pubkey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get information about the running coinstack
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getInfo(options) {
        return exports.V1ApiFp(this.configuration).getInfo(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets current network fee estimates for \'fast\', \'average\', and \'slow\' tx confirmation times
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getNetworkFees(options) {
        return exports.V1ApiFp(this.configuration).getNetworkFees(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get transaction specific data directly from the node
     * @param {V1ApiGetTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getTransaction(requestParameters, options) {
        return exports.V1ApiFp(this.configuration).getTransaction(requestParameters.txid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get transaction history by address or xpub
     * @param {V1ApiGetTxHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getTxHistory(requestParameters, options) {
        return exports.V1ApiFp(this.configuration).getTxHistory(requestParameters.pubkey, requestParameters.page, requestParameters.pageSize, requestParameters.contract, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all unspent transaction outputs for an address or xpub  Examples 1. Bitcoin (address) 2. Bitcoin (xpub)
     * @param {V1ApiGetUtxosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getUtxos(requestParameters, options) {
        return exports.V1ApiFp(this.configuration).getUtxos(requestParameters.pubkey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sends raw transaction to be broadcast to the node.
     * @param {V1ApiSendTxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    sendTx(requestParameters, options) {
        return exports.V1ApiFp(this.configuration).sendTx(requestParameters.sendTxBody, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.V1Api = V1Api;
